<template>
    <main role="main">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="page-con">
            <div class="page-list-con">
            <ul>
                <li class="title-box">
                <a class="back-btn" href="/media">back</a>
                        
                <div class="title-txt">
                    <p class="time">{{data.date}}｜  {{data.category_name}}</p>
                    <h3>{{data.title}}</h3>
                </div>
                </li>
                <li class="list-txt-con">
                <Socialmedia></Socialmedia>
                <div  class="list-txt">
                    <div>
                        <div v-html="data.desc"></div>
                    </div>
                    <a class="back-btn" href="media">back</a>
                </div>
                </li>
                <li class="prev-next">
                <a :href="prev.data.is_link ? prev.data.link : '/media/' + prev.id" :target="prev.data.is_link ? '_blank' : false" v-if="Object.keys(prev).length > 0">
                    <div class="prev">
                    <div>
                        <p>prev</p>
                        <i></i>
                    </div>
                    <p>
                        {{prev.data.date}} {{prev.data.title}}
                    </p>
                    </div>
                </a>
                <a :href="next.data.is_link ? next.data.link : '/media/' + next.id" :target="next.data.is_link ? '_blank' : false" v-if="Object.keys(next).length > 0">
                    <div class="next">
                    <p>
                        {{next.data.date}} {{next.data.title}}
                    </p>
                    <div>
                        <p>next</p>
                        <i></i>
                    </div>
                    </div>
                </a>
                
                </li>
            </ul>
            </div>
        </div>
        <IndexFooter></IndexFooter>
    </main>
</template>
<script>
import {fb, db } from '../../firebase'
export default {
  name: 'MediaInfo',
  data () {
    return {
        id:this.$route.params.id,
        data:{},
        datas:[],
        section:{},
        next:{},
        prev:{},
        isLoading: false,
        fullPage: true
    }
  },
  mounted () {
    this.GetCategory();
  },
  methods: {
    FindName(selected) {
        if (this.section.list.find(x=>x.id == selected))
            return this.section.list.find(x=>x.id == selected).name;
        else 
            return ''
    },
    GetCategory() {
        this.isLoading = true;
        db.collection(this.$t('DB.CATEGORY')).doc('media').get().then((doc) => {
            if (doc.exists) {
                this.section = doc.data();
                this.section.list.sort( (d1, d2) => d1.order - d2.order);
                this.Get();
            } 
        }).catch((error) => {
            console.log("Error getting document:", error);
            this.isLoading = false;
        });
        
    },
    Get() {
      var vm = this;
      // 取得列表
        db.collection(this.$t('DB.NEWS')).where('selected', '==', 'media').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                var item = doc.data();
                item.category_name =  this.FindName(doc.data().list_selected);
                var data = {"id": doc.id, "data": item};
            
                this.datas.push(data);
            });
            this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);

            if ( this.datas.find(x => x.id == vm.id) ) {
                this.data = this.datas.find(x => x.id == vm.id).data;
                //   取得目前index
                var index = this.datas.findIndex(x => x.id == vm.id);

                if ( index > 0 ) {
                    this.prev = this.datas.at(index-1)
                } 

                if ( index+1 < this.datas.length) {
                this.next =  this.datas.at(index+1)
                }
                this.isLoading = false;
            } else {
                this.isLoading = false;
                window.location.href = "/media";
            }
     
        }).catch((error) => {
            console.log("Error getting document:", error);
            this.isLoading = false;
        });
    }
  }
}
</script>
<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/index/MediaInfo.vue